module.exports = __webpack_public_path__ + "img/dart.ab4334ae.png";